import { VIEW_FILE_PERMISSIONS } from "@/services/fileBrowser"

export default [
  {
    path: "/files",
    name: "FileBrowser",
    component: () => import("@/views/file/FileBrowserOverview"),
    meta: {
      title: "nav.file.overview",
      // Any-of, mirroring `NAV_GATES["nav-file"]`: the browser is worth opening as soon as one of the
      // eight file-bearing types is readable, and it shows only the branches the caller may read.
      requiresAuth: true,
      requiresPermissions: VIEW_FILE_PERMISSIONS,
    },
  },
]
